module.exports = __webpack_public_path__ + "img/model3.2447cc20.png";